// 客户端本机内置信令端口。
// 与中央 server 的默认端口(58231)分开，避免两者在同一台电脑上抢占/误路由。
export const DEFAULT_CLIENT_PORT = 58233;

// 桌面客户端固定的中央服务入口。网页端使用当前访问页面的 origin，
// 因此同一套 Web 构建可以部署到生产、测试或局域网域名而不需要重新编译。
export const CENTRAL_SERVER_URL = 'https://remote.5674321.xyz';

/**
 * Resolve the service origin used by the browser client.
 *
 * The Web app is served by the same Fastify process as its REST and WebSocket
 * endpoints. Using location.origin keeps API calls and signaling on the host
 * the user actually opened, including preview domains and local deployments.
 * Non-browser callers (Electron main/renderer and tests) retain the product
 * service fallback.
 */
export function getCurrentServerUrl(): string {
  if (typeof window !== 'undefined') {
    const protocol = window.location?.protocol;
    const origin = window.location?.origin;
    if ((protocol === 'http:' || protocol === 'https:') && origin) return origin;
  }
  return CENTRAL_SERVER_URL;
}

/** Convert a server origin to its matching WebSocket endpoint. */
export function toWebSocketUrl(serverUrl: string, path = '/ws'): string {
  const url = new URL(serverUrl);
  if (url.protocol === 'https:') url.protocol = 'wss:';
  else if (url.protocol === 'http:') url.protocol = 'ws:';
  else throw new Error(`Unsupported server protocol: ${url.protocol}`);
  url.pathname = path;
  url.search = '';
  url.hash = '';
  return url.toString();
}
